import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'News', path: '/news' },
  { label: 'Patch Notes', path: '/patch-notes' },
  { label: 'Newsletter', path: '/newsletter' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

const categories = [
  { label: 'Warzone', path: '/news' },
  { label: 'Multiplayer', path: '/news' },
  { label: 'Zombies', path: '/news' },
  { label: 'Esports', path: '/news' },
  { label: 'Leaks', path: '/news' },
  { label: 'Community', path: '/news' },
];

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] border-t border-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-6 pt-12 pb-6">

        {/* Main row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="font-['Barlow_Condensed'] font-black text-white text-xl tracking-tight leading-none">
                CALL<span className="text-[#999]">OF</span>DUTY
                <span className="text-[#00ff41] ml-1">NEXT</span>
              </span>
            </Link>
            <p className="text-[#555] text-sm leading-relaxed">
              Your #1 source for Call of Duty intel. Not affiliated with Activision or Microsoft.
            </p>
            <div className="flex items-center gap-3 mt-4">
              {[
                { icon: 'ri-twitter-x-line', label: 'X' },
                { icon: 'ri-youtube-line', label: 'YouTube' },
                { icon: 'ri-discord-line', label: 'Discord' },
                { icon: 'ri-instagram-line', label: 'Instagram' },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  rel="nofollow noopener noreferrer"
                  aria-label={s.label}
                  className="w-8 h-8 flex items-center justify-center border border-[#2a2a2a] text-[#555] hover:text-white hover:border-[#444] transition-all cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Navigate */}
          <div>
            <p className="font-['Barlow_Condensed'] font-bold text-xs tracking-[0.2em] text-[#555] uppercase mb-4">Navigate</p>
            <ul className="space-y-2">
              {navLinks.map((l) => (
                <li key={l.path + l.label}>
                  <Link to={l.path} className="text-[#777] hover:text-white text-sm transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <p className="font-['Barlow_Condensed'] font-bold text-xs tracking-[0.2em] text-[#555] uppercase mb-4">Categories</p>
            <ul className="space-y-2">
              {categories.map((c) => (
                <li key={c.label}>
                  <Link to={c.path} className="text-[#777] hover:text-white text-sm transition-colors cursor-pointer">
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Newsletter */}
          <div>
            <p className="font-['Barlow_Condensed'] font-bold text-xs tracking-[0.2em] text-[#555] uppercase mb-4">Newsletter</p>
            <p className="text-[#555] text-sm mb-4">Get the latest CoD intel in your inbox.</p>
            <form
              id="footer-newsletter-form"
              data-readdy-form
              onSubmit={(e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
                fetch('https://readdy.ai/api/form/d70pm2pqa83q0hmd1f0g', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                  body: data.toString(),
                }).then(() => {
                  form.reset();
                  const btn = form.querySelector('button');
                  if (btn) { btn.textContent = 'DONE!'; btn.disabled = true; }
                });
              }}
              className="flex gap-0"
            >
              <input
                type="email"
                name="email"
                placeholder="your@email.com"
                required
                className="flex-1 bg-[#111] border border-[#2a2a2a] border-r-0 text-white text-xs px-3 py-2 focus:outline-none focus:border-[#444] placeholder-[#444] min-w-0"
              />
              <button
                type="submit"
                className="shrink-0 bg-[#00ff41] text-black font-['Barlow_Condensed'] font-black text-xs px-4 py-2 hover:bg-[#00e63a] transition-colors cursor-pointer whitespace-nowrap"
              >
                GO
              </button>
            </form>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#1a1a1a] pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[#444] text-xs">
            &copy; 2026 CallOfDutyNext.com — All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <Link to="/privacy-policy" className="text-[#444] hover:text-[#777] text-xs transition-colors cursor-pointer">Privacy Policy</Link>
            <span className="text-[#2a2a2a]">|</span>
            <Link to="/terms" className="text-[#444] hover:text-[#777] text-xs transition-colors cursor-pointer">Terms of Use</Link>
            <span className="text-[#2a2a2a]">|</span>
            <Link to="/disclaimer" className="text-[#444] hover:text-[#777] text-xs transition-colors cursor-pointer">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
